const currencyMap = {
  JPY: { symbol: '¥' },
  BGN: { symbol: 'Lv' },
  CZK: { symbol: 'Kc' },
  DKK: { symbol: 'DKK' },
  ILS: { symbol: 'NIS' },
  GBP: { symbol: '£' },
  HUF: { symbol: 'Ft' },
  LTL: { symbol: 'Ls' },
  LVL: { symbol: 'Lvl' },
  PLN: { symbol: 'zł' },
  RON: { symbol: 'L' },
  SEK: { symbol: 'SEK' },
  CHF: { symbol: 'CHF' },
  NOK: { symbol: 'NKr' },
  HRK: { symbol: 'HRK' },
  RUB: { symbol: 'R' },
  TRY: { symbol: 'TL' },
  AUD: { symbol: 'AUD' },
  BRL: { symbol: 'R$' },
  CAD: { symbol: 'CDN$' },
  CNY: { symbol: 'Y' },
  HKD: { symbol: 'HK$' },
  IDR: { symbol: 'Rp' },
  INR: { symbol: 'Rs' },
  KRW: { symbol: '₩' },
  MXN: { symbol: 'Mex$' },
  MYR: { symbol: 'RM' },
  NZD: { symbol: 'NZ$' },
  PHP: { symbol: 'P' },
  SGD: { symbol: 'S$' },
  THB: { symbol: 'Bt' },
  ZAR: { symbol: 'R' },
  USD: { symbol: '$' },
  EUR: { symbol: '€' },
};

export const getCurrencySymbol = (currencyCode: string): string => {
  const currency = currencyMap[currencyCode?.toUpperCase()];
  return currency?.symbol || null;
};
